var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{staticClass:"tabs-list",model:{value:(_vm.currentTabIndex),callback:function ($$v) {_vm.currentTabIndex=$$v},expression:"currentTabIndex"}},[_c('el-tab-pane',{staticClass:"tabs-content",attrs:{"label":"代下声明","name":"second"}},[_c('download')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }